/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import Icon from 'components/icon';
import Money from 'components/money';
import { Box, Text } from '@towersystems/towersystems-design-system';
import Card from 'components/card';

const getCalendarValueInMonths = (plan) => {
    switch (plan.period_unit) {
        case 'year':
            return 12 * plan.period;
        case 'month':
            return plan.period;
    }
};

const Plan = ({ plan, onClick, disabled, selected, licenseAddon, numberLicenses }) => {
    return (
        <Card
            className={classNames([
                'select-support-plan__list-item',
                { 'plan-selected': selected },
                { 'plan-disabled': disabled },
            ])}
            onClick={onClick}
        >
            <Card.Section padding='xxlarge' display='flex'>
                <Box display='flex' justifyContent='spaceBetween' alignItems='center' width='full'>
                    <Box>
                        <Text>{plan.name}</Text>
                    </Box>
                    <Box>
                        <Box className='plan__amount-details'>
                            AUD <Money value={plan.price / 100} /> /{' '}
                            {plan.period} {plan.period_unit}
                        </Box>
                    </Box>
                </Box>
            </Card.Section>
        </Card>
    );
};

export default Plan;
